@if (!isGridLoading()) {
  <dv-grid [actions]="actions()" class="assets-grid">
    <ag-grid-angular
      vtGridWithSidesheet
      dvPinSelectedRow
      class="ag-theme-devinco"
      [gridOptions]="gridOptions"
      (selectionChanged)="onSelectionChanged($event)">
    </ag-grid-angular>
  </dv-grid>
}

<ng-template #menuPanelTemplate>
  <app-timed-marker-map-menu-panel
    [showSettings]="true"
    [hideGroupMarkers]="true"
    [mapSetting]="mapSetting"
    (autoRefreshClicked)="onAutoRefreshClicked($event)"
    (autoZoomFitClicked)="
      onAutoZoomFitClicked($event)
    "></app-timed-marker-map-menu-panel>
</ng-template>
